<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            ActivePage: { type: String, required: true },
            workspaceId: { type: Number, required: true },
            tchProjectId: { type: Number, required: true },
            projectId: { type: String, required: true },
            planId: { type: String, required: true, default: null }
        }
    })
    export default class ProjectNavigation extends Vue
    {
    }
</script>

<template>
    <div>        
        <ul class="nav nav-pills">
            <li class="nav-item" :class="{'active2': ActivePage === 'summary'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/summary/${workspaceId}/${tchProjectId}/${projectId}`">
                    Settings
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'revenues'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/revenues/${workspaceId}/${tchProjectId}/${projectId}/${planId}`">
                    Revenues
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'resources'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/resource-allocations/${workspaceId}/${tchProjectId}/${projectId}/${planId}`">
                    Resources
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'expenses'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/expense-allocations/${workspaceId}/${tchProjectId}/${projectId}/${planId}`">
                    Expenses
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'capex'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/capex/${workspaceId}/${tchProjectId}/${projectId}/${planId}`">
                    Capex
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'pnl'}">
                <a class="nav-link" v-sanitizedHref="`/#/q/project/pnl/${workspaceId}/${tchProjectId}/${projectId}/${planId}`">
                    P&L
                </a>
            </li>
        </ul>
        <hr class="mt-0 mb-4" style="border-color: #bbb;" />
    </div>
</template>

<style scoped>
    .nav-pills li a {
        border-radius: 0;
        color: black;
        background-color: transparent;
    }

        .nav-pills li a:hover {
            color: gray;
        }


    .nav-pills li.active2 {
        border-bottom: 3px solid blue;
    }

        .nav-pills li.active2 a {
            color: blue;
        }

</style>